import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let store = new Vuex.Store({
    state:{
        parameterUrl:'f3993cadb7ca430598988266e6e896b9',
        userData:{},
        stat:0
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js